import {SiteadminController} from "SiteadminController";
import SectionSelector from 'diy/site-admin/section-selector/SectionSelector';
import l10n = require('diy/util/l10n');
import features = require('diy/util/features');
import $ = require('jquery');
let api = require<any>('../api');
import globalEvents = require('diy/util/globalEvents');

import {showDialog, hideDialog} from '../../section-selector/guidanceDialog';

class Controller implements SiteadminController {

    private controllerLoaded = false;
    private sectionSelector = new SectionSelector();

    afterFillContent(el: HTMLElement, response: any, contentElement: JQuery) {
        this.sectionSelector.afterFillContent(el, response.data.data, contentElement);

        api.updateTitle(l10n.getString('sectionSelector.window.title'));
        api.updateDescr(l10n.getString('sectionSelector.window.description'));
        api.updateButtons({});
        api.updateNavi({});
        api.updateHelpTopic('addsections');
        api.updateFeatureGuidanceHelp('sections');
        this.controllerLoaded = true;

        $(document.body).trigger('SectionSelectorOpened.BSA');
        globalEvents.trigger('diy-tracking-section-selector-opened');
    };

    allowSwitch() {
        return this.controllerLoaded;
    };

    show() {
        // Only show guidance flyout if feature enabled and we have enough space vertically
        let shouldShowGuidanceFlyout = features('showSectionsGuidanceFlyout') && window.innerHeight >= 555;
        if (shouldShowGuidanceFlyout) {
            showDialog({
                onDismiss: () => {
                    features.disableFeature('showSectionsGuidanceFlyout').then(() => {
                        hideDialog();
                        $('#cc-sa-item-sections').click();
                    });
                }
            });
            api.close();
        } else {
            this.sectionSelector.show();
        }
    };

    hide() {
        this.sectionSelector.hide();
    };

    getWindowSize() {
        return this.sectionSelector.getWindowSize();
    }
}

let controllerInstance = new Controller();
export = controllerInstance;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/main/controllers/sectionSelector.ts
 **/